import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react"
import { AzureOAuthButton, AzureOAuthButtonProps } from "./AzureOAuthButton"

/**
 * 
 * description
 * 
 * ###Import to use it
 *
 *```jsx
 *   import { AzureOAuth } from '@eco/react-lib'
 *```
 *
 *### Usage
 *
 *```jsx
 *<AzureOAuth 
 *   label={string} 
 *   isSubmit={boolean} 
 *   disabled={boolean}
 />
 *```
 *
 *### Basic Example
 */

export const AzureOAuth = (props: Props) =>  {

    return (
        <MsalProvider instance={msalInstance}>
            <AzureOAuthButton {...props} />
        </MsalProvider>
    )
}

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
 export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID!,
        authority: process.env.REACT_APP_AZURE_AUTHORITY,
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};

const msalInstance = new PublicClientApplication(msalConfig);

type Props = AzureOAuthButtonProps
